module.exports = __webpack_public_path__ + "img/what_type_of_video_game_suits_you_splash.c0d355bc.jpg";